import { Component, ElementRef, HostListener, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-top-navbar',
  standalone: true,
  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.scss',
  imports: [RouterLink, CommonModule]
})
export class TopNavbarComponent {
  @Input() hideFreeTrial = false;
  scrolled = false;
  menuOpen = false;

  constructor(
    private el: ElementRef<HTMLElement>,
    public sharedService: SharedService
  ) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 20;
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  public scrollToTop(event?: Event): void {
    event?.preventDefault();

    // scroll document just in case (no-op if body not scrollable)
    const docEl = document.scrollingElement || document.documentElement;
    if (docEl) docEl.scrollTo({ top: 0, behavior: 'smooth' });

    // also scroll the host element (this covers :host overflow-y: auto)
    const host = this.el.nativeElement;
    if (host && 'scrollTo' in host) {
      try { host.scrollTo({ top: 0, behavior: 'smooth' } as any); }
      catch { host.scrollTop = 0; }
    } else if (host) {
      host.scrollTop = 0;
    }
  }
}
